// =============================================================================
// NAD+ Why Different Section Component
// =============================================================================

export class NADWhyDifferent {
  private element: HTMLElement;
  private observer: IntersectionObserver | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.setupScrollAnimation();
  }

  /**
   * Fade in each card as it becomes visible; stagger delays come from the
   * nth-child rules in the section SCSS
   */
  private setupScrollAnimation(): void {
    const cards = this.element.querySelectorAll<HTMLElement>('.nad-why-different__card');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            this.observer?.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      }
    );

    cards.forEach((card) => this.observer?.observe(card));
  }

  public destroy(): void {
    this.observer?.disconnect();
    this.observer = null;
    this.element.querySelectorAll('.nad-why-different__card.animate-in')
      .forEach(el => el.classList.remove('animate-in'));
  }

  static initializeAll(): void {
    document.querySelectorAll<HTMLElement>('.nad-why-different')
      .forEach(el => {
        if (!(el as any)._nadComponentInstance) {
          (el as any)._nadComponentInstance = new NADWhyDifferent(el);
        }
      });
  }
}
